import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectPinnedFunnelMap,
  selectFunnelMapsList,
  selectFunnelMapsIsLoading,
} from '../../../reducers/funnelMapsReducer';

export const useNonPinnedFunnelMaps = () => {
  const pinnedFunnelMap = useSelector(selectPinnedFunnelMap);
  const funnelMapsList = useSelector(selectFunnelMapsList);
  const isLoading = useSelector(selectFunnelMapsIsLoading);

  return useMemo(() => {
    if (!pinnedFunnelMap) {
      return {
        funnelMapsList: funnelMapsList ?? [],
        isLoading,
      };
    }
    //filtering like this to handle the (unlikely) case there is more than 1 pinned - want to return all the rest of the funnels
    return {
      funnelMapsList: funnelMapsList.filter((funnelMap) => funnelMap.id !== pinnedFunnelMap.id),
      isLoading,
    };
  }, [pinnedFunnelMap, funnelMapsList, isLoading]);
};
